export default class BlockVideo {
    constructor(container, options) {
        const defaultOptions = {
            plyr: '.video-plyr',
            moduleContainer: '.video-container',
            loaderEnabled: false
            
        };

        this.options = Object.assign({}, defaultOptions, options);
       
        this.videoPaused = true;

        this.container = document.querySelector(container);
        if(this.container) {
            this.plyr = this.container.querySelector(this.options.plyr);
            this.moduleContainer = this.container.querySelector(this.options.moduleContainer);
            this.init();
            this.setEvents();
        }
    }

    setEvents() {
        this.container.addEventListener('click', () => {
           
            if (this.videoPaused) {               
                this.videoPlayer.play();
            }else{
                this.videoPlayer.pause();
            }

            this.videoPaused = !this.videoPaused;

        });
    }

    init() {
        this.videoPlayer = new Plyr(this.plyr, {
            controls: [
                'play-large',
                'play',                
                'progress',
                'mute',
                'fullscreen',
                'volume'
            ],
            debug: false,
            volume: 1,
            autoplay: false          
        });

        // Set the poster after initialization
        this.videoPlayer.poster = this.plyr.dataset.poster;

        this.videoPlayer.on('ready', () => {
            this.moduleContainer.classList.add('active');
            this.videoPlayer.volume = 1
        });
    }
}